import { GamepadCircleRightIcon } from './GamepadCircleRightIcon';

/**
 * author: Haley Halcyon
 * id 97C7D65D-6073-473D-9D21-7DCB3CA7556D
 * name gamepad-circle-right
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-circle-right.svg
 * tags
 * - Gaming / RPG 
 */
export const ControllerCircleRightIcon = GamepadCircleRightIcon;
export default ControllerCircleRightIcon